import { render, staticRenderFns } from "./ConfirmActualization.vue?vue&type=template&id=b580cf1e"
import script from "./ConfirmActualization.vue?vue&type=script&lang=js"
export * from "./ConfirmActualization.vue?vue&type=script&lang=js"
import style0 from "./ConfirmActualization.vue?vue&type=style&index=0&id=b580cf1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports